import { AgmCoreModule } from '@agm/core';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DataTableModule } from "angular-6-datatable";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxBarcodeModule } from 'ngx-barcode';
import { SharedModule } from './shared/shared.module';
import { NgxPrintModule } from 'ngx-print';
import { DataTablesModule } from 'angular-datatables';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule

  
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerComponent } from './components/customer/customer.component';
import { P404Component } from './components/error/404.component';
import { P500Component } from './components/error/500.component';
import { FeeComponent } from './components/fee/fee.component';
import { FeeTypeComponent } from './components/fee-type/fee-type.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent, ModalContentComponent } from './components/login/login.component';
import { PaybillComponent } from './components/paybill/paybill.component';
import { PaymentTypeComponent } from './components/payment-type/payment-type.component';
import { TimeoutComponent } from './components/timeout/timeout.component';
import { UserComponent } from './components/user/user.component';
import { UserPositionComponent } from './components/user-position/user-position.component';
import { StayTypeComponent } from './components/stay-type/stay-type.component';
import { MaterialModule } from './material/material.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AuthGuard } from './auth.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PaginatorComponent } from './shared/paginator/paginator.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ClearPaymentComponent } from './components/clear-payment/clear-payment.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { PrefixComponent } from './components/prefix/prefix.component';
import { PlaceMapComponent } from './components/place-map/place-map.component';
import { InvoiceHistory } from './components/invoice-history/invoice-history';
import { LogsComponent } from './components/logs/logs.component';
import { MarketPlaceComponent } from './components/market-place/market-place.component';
import { TestComponent } from './components/test/test.component';
import { RequestComponent } from './components/request/request.component';
import { SubjectComponent } from './components/subject/subject.component';
import { ChartComponent } from './components/chart/chart.component';
import { MapsGoogleComponent } from './components/maps-google/maps-google.component';
import { MapsVectorComponent } from './components/maps-vector/maps-vector.component';
import { CustomerRequestComponent } from './components/customer-request/customer-request.component';
import { UserZoneComponent } from './components/user-zone/user-zone.component';
import { PrintInvoiceComponent } from './components/print-invoice/print-invoice.component';
import { PrintBillComponent } from './components/print-bill/print-bill.component';
import { PrintBillComponent_3X4 } from './components/print-bill_3X4/print-bill-3x4.component';
import { PrintInformComponent } from './components/print-inform/print-inform.component';
import { ReportInvoiceComponent } from './components/report-invoice/report-invoice.component';
import { ReportInformComponent } from './components/report-inform/report-inform.component';
import { ReportBillComponent } from './components/report-bill/report-bill.component';
import { ReporLogsComponent } from './components/repor-logs/repor-logs.component';
import { ImportBillComponent } from './components/import-bill/import-bill.component';
import { ImportInvoiceComponent } from './components/import-invoice/import-invoice.component';
import { ImportFeeComponent } from './components/import-fee/import-fee.component';
import { PrintInformNormalComponent } from './components/print-inform-normal/print-inform-normal.component';
import { PrintInvoiceNormalComponent } from './components/print-invoice-normal/print-invoice-normal.component';
import { PrintBillNormalComponent } from './components/print-bill-normal/print-bill-normal.component';
import { PrintReportInformComponent } from './components/print-report-inform/print-report-inform.component';
import { PrintReportInvoiceComponent } from './components/print-report-invoice/print-report-invoice.component';
import { PrintReportBillComponent } from './components/print-report-bill/print-report-bill.component';
import { PrintReportLogsComponent } from './components/print-report-logs/print-report-logs.component';
import { InvoiceNgxTableComponent } from './components/invoice-ngx-table/invoice-ngx-table.component';
import { ReportBillCancelComponent } from './components/report-bill-cancel/report-bill-cancel.component';
import { ReportFeeCancelComponent } from './components/report-fee-cancel/report-fee-cancel.component';
import { ReportInvoiceCancelComponent } from './components/report-invoice-cancel/report-invoice-cancel.component';
import { PrintReportBillCancelComponent } from './components/print-report-bill-cancel/print-report-bill-cancel.component';
import { PrintReportInvoiceCancelComponent } from './components/print-report-invoice-cancel/print-report-invoice-cancel.component';
import { RequestGeneralComponent } from './components/request-general/request-general.component';
import { PrintRequestGeneralComponent } from './components/print-request-general/print-request-general.component';
import { PrintInvoiceMultiFileComponent } from './components/print-invoice-multi-file/print-invoice-multi-file.component';
import { PrintInformMultiFileComponent } from './components/print-inform-multi-file/print-inform-multi-file.component';
import { PrintCustomerRequestComponent } from './components/print-customer-request/print-customer-request.component';
import { PrintReportInformComponentExcel } from './components/print-report-inform-excel/print-report-inform-excel.component';
import { PrintReportInvoiceComponentExcel } from './components/print-report-invoice-excel/print-report-invoice-excel.component';
import { PrintReportInvoiceCancelComponentExcel } from './components/print-report-invoice-cancel-excel/print-report-invoice-cancel-excel.component';
import { PrintReportBillComponentExcel } from './components/print-report-bill-excel/print-report-bill-excel.component';
import { PrintReportBillCancelComponentExcel } from './components/print-report-bill-cancel-excel/print-report-bill-cancel-excel.component';
// import { ManageMarketComponent } from './components/manage-market/managemarket.component';
import {PrintInformComponent_3X4} from './components/print-inform_3X4/print-inform-3x4.component';
import {PrintInvoiceComponent_3X4} from './components/print-invoice_3X4/print-invoice-3x4.component';


@NgModule({
  imports: [
    NgxPrintModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    MaterialModule,
    DataTableModule,
    HttpClientModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    NgxDatatableModule,
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    CarouselModule.forRoot(),
    Ng2GoogleChartsModule,
    SharedModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA2ldIhQM1ULoXAF4GZYHbd6v6B4YCACxE',
      libraries: ['places']
    }),
    NgMultiSelectDropDownModule.forRoot(),
    NgxBarcodeModule,
    DataTablesModule
  ],
  declarations: [
    AppComponent,
    CustomerComponent,
    P404Component,
    P500Component,
    FeeComponent,
    FeeTypeComponent,
    LayoutComponent,
    LoginComponent,
    PaybillComponent,
    PaymentTypeComponent,
    TimeoutComponent,
    UserComponent,
    UserPositionComponent,
    StayTypeComponent,
    TimeoutComponent,
    PaginatorComponent,
    InvoiceComponent,
    ModalContentComponent,
    DashboardComponent,
    ClearPaymentComponent,
    PrefixComponent,
    PlaceMapComponent,
    InvoiceHistory,
    LogsComponent,
    MarketPlaceComponent,
    TestComponent,
    RequestComponent,
    SubjectComponent,
    PrintBillComponent_3X4,
    ChartComponent,
    MapsGoogleComponent,
    MapsVectorComponent,
    CustomerRequestComponent,
    UserZoneComponent,
    PrintInvoiceComponent,
    PrintBillComponent,
    PrintInformComponent,
    ReportInvoiceComponent,
    ReportInformComponent,
    ReportBillComponent,
    ReporLogsComponent,
    ImportBillComponent,
    ImportInvoiceComponent,
    ImportFeeComponent,
    PrintInformNormalComponent,
    PrintInvoiceNormalComponent,
    PrintBillNormalComponent,
    PrintReportInformComponent,
    PrintReportInvoiceComponent,
    PrintReportBillComponent,
    PrintReportLogsComponent,
    InvoiceNgxTableComponent,
    ReportBillCancelComponent,
    ReportFeeCancelComponent,
    ReportInvoiceCancelComponent,
    PrintReportBillCancelComponent,
    PrintReportInvoiceCancelComponent,
    RequestGeneralComponent,
    PrintRequestGeneralComponent,
    PrintInvoiceMultiFileComponent,
    PrintInformMultiFileComponent,
    PrintCustomerRequestComponent,
    PrintReportInformComponentExcel,
    PrintReportInvoiceComponentExcel,
    PrintReportInvoiceCancelComponentExcel,
    PrintReportBillComponentExcel,
    PrintReportBillCancelComponentExcel,
    // ManageMarketComponent,
    PrintInformComponent_3X4,
    PrintInvoiceComponent_3X4

  ],
  providers: [{
    provide: LocationStrategy,
    useClass: PathLocationStrategy
  }, AuthGuard],
  bootstrap: [AppComponent],
  entryComponents: [ModalContentComponent]
})
export class AppModule { }
